import React, { useContext, useRef } from 'react';
import { WMTooltip } from '@walkme/wm-ui';
import cc from 'classcat';

import { AppTableContext } from '../../AppTableContext';
import { withSkeleton } from '../../helpers/withSkeleton';

import classes from './TitleCell.module.scss';

const Subtitle = ({ subTitle, id, className }: { subTitle: $TSFixMe; id: $TSFixMe; className?: $TSFixMe }) => {
    const { tableDataTestid } = useContext(AppTableContext);
    const contentRef = useRef(null);

    const shouldShowTooltip = () => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'offsetWidth' does not exist on type 'nev... Remove this comment to see the full error message
        return contentRef?.current?.offsetWidth < contentRef?.current?.scrollWidth;
    };

    return (
        <WMTooltip condition={shouldShowTooltip()} title={subTitle || ''}>
            <div className={cc([classes.subtitle, className])} data-testid={`${id}-subtitle-${tableDataTestid}`} ref={contentRef}>
                <span>{subTitle}</span>
            </div>
        </WMTooltip>
    );
};

export default withSkeleton({ width: 150, height: 12 })(Subtitle);
